'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ArticleCard;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders a single teaser card.
 * @param {string} url The (article) URL to link to.
 * @param {string} imageSrc The source URL of the teaser image.
 * @param {string} title The title of the article.
 * @param {string} authors A string with the author information
 * @param {string} lead The lead of the article
 * @returns {XML}
 */
function ArticleCard(_ref) {
  var url = _ref.url,
      imageSrc = _ref.imageSrc,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '░░░ ░░░░░░░' + ' ░░░░░░' : _ref$title,
      _ref$authors = _ref.authors,
      authors = _ref$authors === undefined ? '░░░ ░░░, ░░░░░░' : _ref$authors,
      _ref$lead = _ref.lead,
      lead = _ref$lead === undefined ? '<p>░░░░░░ ░░░░░ ░░░░░░░░░░' + ' ░░░ ░░░░░░░░ ░░░░░░░░░░░░░ ░░░░░ ░░░ ░░░░░░░░░. ░░░░░░░░░░░░░ ░░░░ ░░ ░░░' + ' ░░░ ░░░░░░░░░░ ░░░░░░░░.</p>' : _ref$lead;

  console.log('IM RENDERING!', url);

  return _react2.default.createElement(
    'a',
    { href: url,
      target: '_top',
      className: 'ui article-teaser card' },
    _react2.default.createElement(
      'div',
      { className: 'image' },
      _react2.default.createElement('img', { src: imageSrc })
    ),
    _react2.default.createElement(
      'div',
      { className: 'content' },
      _react2.default.createElement(
        'div',
        { className: 'header' },
        title
      ),
      _react2.default.createElement('div', { className: 'description', dangerouslySetInnerHTML: { __html: lead } }),
      _react2.default.createElement(
        'div',
        null,
        'Mehr\u2009\u2026'
      )
    ),
    authors !== '' && _react2.default.createElement(
      'div',
      { className: 'extra content' },
      authors
    )
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@ta-interaktiv/react-article-teasers/dist/articleCard.js
// module id = 16
// module chunks = 0